import type { ReceiverItem } from '#shared/contracts/merchant-panel/company-unit.contract'
import type { CompanyItem } from '#shared/contracts/merchant-panel/company/company-list.contract'

export const useCompanyContextStore = defineStore('company-context', () => {
    const companyId = ref<number | null>(null)
    const companyUnitId = ref<number | null>(null)
    const currentCompany = ref<CompanyItem | null>(null)
    const currentReceiver = ref<ReceiverItem | null>(null)
    const needsContextSelection = ref(false)
    const hasNoCompanies = ref(false)
    const isSwitching = ref(false)
    const didInitContext = ref(false)
    const didRestoreContext = ref(false)

    const canRenderForCustomer = computed(() =>
        !needsContextSelection.value || hasNoCompanies.value,
    )
    const shouldShowContextModal = computed(() =>
        needsContextSelection.value && !hasNoCompanies.value,
    )
    const hasActiveCompany = computed(() => companyId.value !== null)

    function $reset() {
        companyId.value = null
        companyUnitId.value = null
        currentCompany.value = null
        currentReceiver.value = null
        needsContextSelection.value = false
        hasNoCompanies.value = false
        isSwitching.value = false
        didInitContext.value = false
        didRestoreContext.value = false
    }

    return {
        companyId,
        companyUnitId,
        currentCompany,
        currentReceiver,
        needsContextSelection,
        hasNoCompanies,
        isSwitching,
        didInitContext,
        didRestoreContext,
        canRenderForCustomer,
        shouldShowContextModal,
        hasActiveCompany,
        $reset,
    }
})
